import { api } from '@/api/client';
import { SchemaForm, SchemaFormValues } from '@/features/SchemaForm';
import { InquiryFormTemplate } from '@/features/SchemaForm/templates/InquiryFormTemplate';
import { useInquiryContactDefaults } from '@/hooks/useInquiryContactDefaults';
import { inquiryPropertyManagementSchema } from '@mr-website/schemas';
import { useMemo } from 'react';

const DiscussManagingPropertiesForm = () => {
  const { defaultValuesCallback: contactDefaultsCallback } = useInquiryContactDefaults();

  const defaultValuesCallback = useMemo(
    () => () => ({
      properties: [{}],
      ...(contactDefaultsCallback?.() ?? {}),
    }),
    [contactDefaultsCallback],
  );

  const handleSubmit = async (values: SchemaFormValues) => {
    await api.post('/inquiry/property-management', values);
  };

  return (
    <SchemaForm
      zodSchema={inquiryPropertyManagementSchema}
      defaultValuesCallback={defaultValuesCallback}
      template={
        <InquiryFormTemplate
          title="Discuss Managing Your Properties"
          description="All fields are required. We will contact you within 24 hours to discuss your management needs."
          successMessage="A Property Manager will be in touch with you shortly."
        />
      }
      variant="inline"
      onSubmit={handleSubmit}
      enableTurnstile
    />
  );
};

export { DiscussManagingPropertiesForm };
